import React from "react";
import { ConfigureButton } from "components";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import { Menu, MenuItem } from "@material-ui/core";
import _ from "lodash";

interface P {
  title: string;
  days: number;
  onChange?: (days: number) => void;
  maxDays?: number;
}
const DaysBefore: React.SFC<P> = ({ title, days, onChange, maxDays }: P) => {
  return (
    <PopupState variant="popover" popupId="demo-popup-menu">
      {popupState => (
        <React.Fragment>
          <ConfigureButton
            leftIcon="bell"
            title={title}
            rightIcon="list"
            rightText={`${days}`}
            {...bindTrigger(popupState)}
          />
          <Menu
            {...bindMenu(popupState)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right"
            }}
          >
            {_.range(1, (maxDays || 14) + 1).map(i => (
              <MenuItem
                key={i}
                onClick={e => {
                  popupState.close(e);
                  if (onChange) {
                    onChange(i);
                  }
                }}
              >
                {i} zile
              </MenuItem>
            ))}
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
};
export default DaysBefore;



// WEBPACK FOOTER //
// ./src/routes/main/components/DaysBefore.tsx